/* globals jQuery */
import 'fitvids.1.1.0'
import 'magnific-popup'

import './slideshows.js'
import responsiveNav from './responsive-nav.jquery.js'
import accordion from './jquery.accordion-new.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    $.fn.accordion = accordion

    // Make nav menu nice & responsive
    $('nav.main-nav').responsiveNav({
        navType: 'dropdown', //default option for dropdown type use 'dropdown'
        closeOnOutsideClick: false, //set to false if using dropdown type
        showTabsOnFocus: true,
    });

    // Responsive Videos
    $('.rtecontent').fitVids();

    // Accordions
    $('dl.accordion').accordion();

	//SEARCH POPUP
    $('.js-open-search').magnificPopup({
		type:'inline',
		alignTop: true,
		modal: true,
		midClick: true, // Allow opening popup on middle mouse click. Always set it to true if you don't provide alternative source in href.
		mainClass: 'mfp-fade',
		focus : '#s',
		callbacks: {
			// When elemened is focused, some mobile browsers in some cases zoom in
			// It looks not nice, so we disable it:
			beforeOpen: function() {
					if($(window).width() < 700) {
						this.st.focus = false;
					} else {
						this.st.focus = '#s';
					}
				}
		}
	});
	$(document).on('click', '.js-close-search', function (e) {
		e.preventDefault();
		$.magnificPopup.close();
	});
	// esc key search popup close.
	$(document).on('keyup',function(e) {
		if (e.key === 'Escape' || e.key === 'Esc' || e.key === 27) {
			e.preventDefault();
			$.magnificPopup.close();
		}
	});
	/* END SEARCH CONTROLS */

	// Share widget slide out
	$('.share-widget__link').hover(function(){
		$( this ).find('.slide-content').stop().animate({width: '230px'}, 400)
	}, function(){
			$( this ).find('.slide-content').stop().animate({width: '-0'}, 400)
	});

	// MAP
	const paths = document.querySelectorAll('path');
	const infoElements = document.querySelectorAll('.pin-info');

	let activePath = '';

	paths.forEach(path => {
		const pathId = path.id;
		const infoElement = document.getElementById(`pin-info-${pathId}`);

		path.addEventListener('mouseover', () => {
			// Show hover state only if not already active or hover
			if (!infoElement.classList.contains('active') && !infoElement.classList.contains('hover')) {
				infoElement.classList.add('hover');
				path.style.fill = 'white';
				path.style.stroke = 'black';
			}
		});

		path.addEventListener('mouseout', () => {
			// Remove hover state if not active
			if (!infoElement.classList.contains('active')) {
				infoElement.classList.remove('hover');
				path.style.fill = '';
				path.style.stroke = '';
			}
		});

		path.addEventListener('click', () => {
			if (activePath !== pathId) {
				// Hide previously active info element and reset its styles
				const previousActiveInfo = document.querySelector('.pin-info.active');
				if (previousActiveInfo) {
					previousActiveInfo.classList.remove('active', 'hover'); // Remove both active and hover
					const previousActivePath = document.querySelector(`path[id="${activePath}"]`);
					if (previousActivePath) {
						previousActivePath.style.stroke = '';
						previousActivePath.style.fill = '';
					}
				}
			}

			// Toggle active state for the clicked pin
			infoElement.classList.toggle('active');

			// Apply visual styles based on active state
			if (infoElement.classList.contains('active')) {
				path.style.stroke = 'black';
				path.style.fill = 'white';
				activePath = pathId;
				} else {
					path.style.stroke = '';
					path.style.fill = '';
					activePath = '';
			}

			// Ensure hover state is removed when clicking, even if already active
			infoElement.classList.remove('hover');
		});
	});

})(jQuery)
